import React from 'react'
import ExpertChatButton from '#src/components/ExpertChatButton'
import classNames from 'classnames'
import { IdentityConsumer } from '#src/containers/Identity'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import { Button } from '@deal/components'
import styles from './styles.css'

interface MessageButtonProps {
  expertId: string
  acceptingNewRequests: boolean | null
  className?: string
}

const MessageButton: React.SFC<MessageButtonProps & WithAnalyticsProps> = ({
  expertId,
  acceptingNewRequests,
  children,
  analytics,
  className
}) => {
  return (
    <IdentityConsumer>
      {({ myself }) => {
        if (!myself || !acceptingNewRequests) {
          return null
        }

        return (
          <ExpertChatButton expertId={expertId}>
            {(startExpertCustomerConversation, loading) => (
              <Button
                variant="secondary-link"
                className={classNames(styles.messageButton, className)}
                disabled={loading}
                onClick={() => {
                  startExpertCustomerConversation ? startExpertCustomerConversation() : null

                  if (analytics) {
                    analytics.events.expertProfileConversationStarted()
                  }
                }}
              >
                {children}
              </Button>
            )}
          </ExpertChatButton>
        )
      }}
    </IdentityConsumer>
  )
}

export default withAnalytics(MessageButton)
